import { render } from "./BasicConfig.vue?vue&type=template&id=1568610f&scoped=true"
import script from "./BasicConfig.vue?vue&type=script&lang=js"
export * from "./BasicConfig.vue?vue&type=script&lang=js"

import "./BasicConfig.vue?vue&type=style&index=0&id=1568610f&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1568610f"]])

export default __exports__